import { render, staticRenderFns } from "./PCupload.vue?vue&type=template&id=290d3edc&scoped=true"
import script from "./PCupload.vue?vue&type=script&lang=js"
export * from "./PCupload.vue?vue&type=script&lang=js"
import style0 from "./PCupload.vue?vue&type=style&index=0&id=290d3edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290d3edc",
  null
  
)

export default component.exports